// Translation from legacy order `refType` to new supported JSONLogic
const orderRefTypeToNew = {
  purchase_order_number: 'purchase',
  sales_order_number: 'sales',
  stock_transfer_order_number: 'stock_transfer',
} as const

export default orderRefTypeToNew
